import { useEffect, useRef, useState } from "react";
import type { Swiper as SwiperInstance } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import iGreenCrown from "../../../assets/icons/green-crown.svg";
import iGreenHeart from "../../../assets/icons/green-heart.svg";
import iPartnersBg from "../../../assets/icons/partners-block/partners-bg.svg";
import iSwiperButton from "../../../assets/icons/swiper-button.svg";
import { getAssetUrl, getMainPageApi } from "../../../api/api";
import { useWidth } from "../../../hooks/use-width";
import { TAwardItem } from "../../../types/types";
import PartnersList from "../partners-block/partners-list/partners-list";
import AwardItem from "./awards-swiper/award-item";
import BlockTitle from "../block-title/block-title";
import "./awards-block.sass";

const getAwardLink = (award: TAwardItem): string | undefined => {
  if (award.isFileLink && award.file?.url) {
    return getAssetUrl(award.file.url);
  }

  if (award.url) {
    return award.url;
  }

  return undefined;
};

const AwardsBlock = () => {
  const swiperRef = useRef<SwiperInstance | null>(null);
  const { isMobileWidth, isDesktopWidth } = useWidth();
  const [awards, setAwards] = useState<TAwardItem[]>([]);

  useEffect(() => {
    getMainPageApi()
      .then((data) => {
        const nextAwards = Array.isArray(data?.data?.awards)
          ? data.data.awards
          : [];
        setAwards(nextAwards);
      })
      .catch(() => {
        setAwards([]);
      });
  }, []);

  return (
    <div className="awards-block">
      <BlockTitle>
        <span>наши партнёры</span>

        <img src={iGreenHeart} className="partners-block__img" alt="" />
      </BlockTitle>

      <PartnersList />

      <img src={iPartnersBg} className="partners-block__bg" alt="" />

      <div className="awards-block__tail">
        <div className="awards-block__upper">
          <BlockTitle>
            <span>Награды</span>

            <img src={iGreenCrown} className="awards-block__img" alt="" />
          </BlockTitle>

          {isDesktopWidth && (
            <div className="awards-block__button-list">
              <img
                src={iSwiperButton}
                className="awards-block__button"
                alt=""
                onClick={() => swiperRef.current?.slidePrev()}
              />

              <img
                src={iSwiperButton}
                className="awards-block__button awards-block__button-right"
                alt=""
                onClick={() => swiperRef.current?.slideNext()}
              />
            </div>
          )}
        </div>

        <div className="awards-block__swiper-wrap">
          <Swiper
            spaceBetween={8}
            slidesPerView="auto"
            navigation
            pagination={{ clickable: true }}
            onSwiper={(swiper: SwiperInstance) => {
              swiperRef.current = swiper;
            }}
          >
            {awards.map((award) => (
              <SwiperSlide key={award.id} style={{ width: "auto" }}>
                <AwardItem
                  img={award.img?.url ? getAssetUrl(award.img.url) : undefined}
                  title={award.title}
                  text={award.description}
                  link={getAwardLink(award)}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        {isMobileWidth && (
          <div className="awards-block__button-list">
            <img
              src={iSwiperButton}
              className="awards-block__button"
              alt=""
              onClick={() => swiperRef.current?.slidePrev()}
            />

            <img
              src={iSwiperButton}
              className="awards-block__button awards-block__button-right"
              alt=""
              onClick={() => swiperRef.current?.slideNext()}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default AwardsBlock;
